export const CONVOGRID_LOGIN_URL =  process.env.REACT_APP_LOGIN_EXTENSION_URL as string;
export const CONVOGRID_ORIGIN = process.env.REACT_APP_CONVOGATE_ORIGIN as string;
export const CONVOCHAT_EXTENSION_ORIGINS = (process.env.REACT_APP_CONVOCHAT_EXTENSION_ORIGINS as string).split(",");
export const CONVOBROKER_SOCKET_URL = process.env.REACT_APP_CONVOBROKER_SOCKET_URL as string
